import styled from 'styled-components';

export const Wrapper = styled.div`
	width: 100%;
	padding-bottom: 4px;
`;

export const TitleRow = styled.div`
	display: flex;
	justify-content: space-between;
	margin-bottom: 6px;
`;

export const Title = styled.h2`
	font-size: 16px;
	line-height: 22px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.subtitle};
`;

export const ParticipantsCountContainer = styled.div`
	display: flex;
	gap: 4px;
`;

export const ParticipantsCountText = styled.p`
	font-size: 13px;
	line-height: 18px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.body};
`;

export const ParticipantsCount = styled.p`
	font-size: 13px;
	line-height: 18px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.title};
`;

export const ParticipantsGrid = styled.div`
	max-height: 400px;
	border: 1px solid ${({ theme }) => theme.colors.transparent.light10};
	border-radius: 5px;
	overflow-y: auto;
`;

export const ParticipantsRow = styled.div`
	display: flex;
	border-bottom: 1px solid ${({ theme }) => theme.colors.transparent.light10};

	&:last-child {
		border-bottom: 0;
	}
`;

export const ParticipantNumber = styled.div`
	padding: 6px 8px;
	font-size: 14px;
	line-height: 19px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.subtitle};
	border-right: 1px solid ${({ theme }) => theme.colors.transparent.light10};
	width: 32px;
`;

export const ParticipantId = styled.div`
	padding: 6px 8px;
	font-size: 14px;
	line-height: 19px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.subtitle};
`;

export const NoParticipants = styled.p`
	font-size: 13px;
	line-height: 18px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.body};
	text-align: center;
`;

export const ShowMoreRow = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 15px;
`;

export const ShowMoreBtn = styled.button`
	font-size: 14px;
	line-height: 22px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.control.secondary};
	cursor: pointer;

	display: flex;
	gap: 4px;
`;

export const ShowMoreIconWrapper = styled.div`
	display: flex;
	align-items: center;
	svg {
		width: 20px;
		height: 20px;

		transform: rotate(-90deg);

		path {
			fill: ${({ theme }) => theme.colors.control.secondary};
		}
	}
`;
